//
//
//
//

import Vue from "vue";
import comicobject from "../script/comicobject";

export default {
  name: 'item_manghua_base',
  props: {
    comic_data: undefined,
    tabinfo:undefined
  },
  data() {
    return {
      comicobject: comicobject,
    }
  },
  computed: {
    total_chapter: function () {
      if (this.comic_data) {
        return this.comicobject.methods.compute_total_chapter(this.comic_data).length
      }
    }
  },
  created() {
    if (this.comic_data && this.comic_data.id) {
      var space_name = this.comic_data.photo_object.space_name;
      var cover_hash_id = this.comic_data.photo_object.cover;
      this.cover_url = this.generate_cover_url(space_name, this.comic_data.id, cover_hash_id)
    }
  },
  methods: {
    on_cover_error: function (e) {
      console.log("on_cover_error:", e)
      var space_name = this.comic_data.photo_object.space_name;
      var hash_id = this.comic_data.photo_object['0'][0];
      var first_compic_url = this.generate_compic_url(space_name, this.comic_data.id, 0, hash_id)
      if (first_compic_url != this.cover_url) {
        console.log('first_compic_url:', first_compic_url)
        Vue.nextTick(() => {
          this.cover_url = first_compic_url;
          this.$forceUpdate();
        });
      }
    }
  }
}
